import * as React from "react";
import { gzip } from "pako";
import { WebPortalClient } from "webportalclient";

export interface UseFileUploadsProps {
    client: WebPortalClient;
    uploadId: string;
    fileSource: File;
    reportProgress: (percentComplete: number) => void;
    cancellationState: CancellationState;
}

export const ExtractBase64String = async (bytes: Uint8Array) => {
    let binaryString = '';
    let length = bytes.byteLength;
    for (let i = 0; i < length; i++) {
        binaryString += String.fromCharCode(bytes[i]);
    }

    return btoa(binaryString);
}

const calculatePercentComplete = (chunkCount: number, totalChunks: number) => Math.round((chunkCount / totalChunks) * 100 + 1);


export class CancellationState {

    ShouldCancel: boolean = false;

    public SetCancellationValue = (value: boolean) => this.ShouldCancel = value;
    
    public GetCancellationState = (): boolean => this.ShouldCancel;
}

const GenerateZippedContent = async (fileSource: File, rangeStart: number, rangeEnd: number): Promise<string> => {
    const fileChunk = fileSource.slice(rangeStart, rangeEnd);
    const buffer = await fileChunk.arrayBuffer();

    return await ExtractBase64String(gzip(buffer));
}

 export const UploadFile = async ({ client, uploadId, fileSource, reportProgress, cancellationState }: UseFileUploadsProps): Promise<boolean> => {
    const chunkSize = 1500000; // 1.5 mb per chunk
    const fileSize = fileSource.size;
    const totalChunks = Math.ceil(fileSize / chunkSize);
    const startIndex = 0;

    for (let chunkCount = startIndex; chunkCount < totalChunks; chunkCount++) {
        if (cancellationState.GetCancellationState()) {
            await client.deleteFileUpload(uploadId);
            return false;
        }     

        const rangeStart = chunkCount * chunkSize;
        let rangeEnd = rangeStart + chunkSize;
        rangeEnd = rangeEnd > fileSize ? fileSize : rangeEnd;

        try {
            await client.fileUpload({
                id: uploadId,
                filePart: await GenerateZippedContent(fileSource, rangeStart, rangeEnd),
                totalSize: fileSize,
                startPosition: rangeStart,
            });

            reportProgress(calculatePercentComplete(chunkCount, totalChunks));

        } catch {
            return false;
        }
    }
    return true;
}


